// extracted by mini-css-extract-plugin
export default {"mv_outer":"TvdGGGbPlVSIVUBjCbKc","mvOuter":"TvdGGGbPlVSIVUBjCbKc","mv":"IK30cE5RVNjc7HjIyysS","h_title":"vQUNCGlsN4MxWjklxOEi","hTitle":"vQUNCGlsN4MxWjklxOEi"};